import { Link } from "react-router-dom";
import { Calendar, Home, Settings, LogOut, LayoutDashboard, MessageCircleQuestion, ChevronDown } from "lucide-react"
import LogoutLink from "../Components/LogoutLink.tsx";
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    //SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubItem,
} from "@/Components/ui/sidebar"
import { ModeToggle } from "./mode-toggle.tsx";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@radix-ui/react-collapsible";
import { AppContext } from "@/App.tsx";
import React from "react";
import { ProjectSelect } from "./project-select.tsx";
//import { useTheme } from "@/Components/theme-provider";

export function AppSidebar() {
    const app = React.useContext(AppContext);
    const [glassmorphismEnabled, setGlassmorphismEnabled] = React.useState(() => {
        const saved = localStorage.getItem('glassmorphism-enabled');
        return saved !== null ? saved === 'true' : true;
    });

    React.useEffect(() => {
        const handleStorageChange = () => {
            const saved = localStorage.getItem('glassmorphism-enabled');
            setGlassmorphismEnabled(saved !== null ? saved === 'true' : true);
        };

        window.addEventListener('storage', handleStorageChange);
        // Also listen for custom event for same-tab updates
        const interval = setInterval(() => {
            const saved = localStorage.getItem('glassmorphism-enabled');
            const current = saved !== null ? saved === 'true' : true;
            if (current !== glassmorphismEnabled) {
                setGlassmorphismEnabled(current);
            }
        }, 100);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(interval);
        };
    }, [glassmorphismEnabled]);
   // const { setTheme } = useTheme();

    //setTheme("darker");

    return (
        <Sidebar className={`z-50 ${glassmorphismEnabled ? 'glassmorphism-card' : ''}`}>
            <SidebarHeader>
            <Link to={"/"}>
                <div className="p-4">
                    <img src="/PPMeasy_logo.svg" />
                    <h3
                        className="font-bold text-center"
                    >
                        Practical Projects Made easy
                    </h3>
                </div>
                </Link>
                {app.projects.length > 0 && (
                    <SidebarMenu>
                        <SidebarMenuItem>
                            <ProjectSelect />
                        </SidebarMenuItem>
                    </SidebarMenu>
                )}
            </SidebarHeader>
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                        {app.projects.length > 0 && (
                            <><Collapsible className="group">
                                    <SidebarMenuItem>
                                        <CollapsibleTrigger asChild>
                                            <SidebarMenuButton>
                                                <LayoutDashboard />
                                                <span>Dashboard</span>
                                                <ChevronDown className="ml-auto h-4 w-4 shrink-0 opacity-50 transition group-data-[state=open]:rotate-180" />
                                            </SidebarMenuButton>
                                        </CollapsibleTrigger>
                                        <CollapsibleContent>
                                            <SidebarMenuSub>
                                                <SidebarMenuSubItem>
                                                    <SidebarMenuButton asChild>
                                                        <Link to={app.selectedProject?.projectTypeId == 2 ? "/ProjectOverview" : "/"}>
                                                            <span>{app.selectedProject?.projectTypeId == 2 ? "Project Overview" : "Multi Project Dashboard"}</span>
                                                        </Link>
                                                    </SidebarMenuButton>
                                                </SidebarMenuSubItem>
                                                <SidebarMenuSubItem>
                                                    <SidebarMenuButton asChild>
                                                        <Link to={"/StatusReports"}>
                                                            <span>Status Reports</span>
                                                        </Link>
                                                    </SidebarMenuButton>
                                                </SidebarMenuSubItem>
                                                {app.authLevel >= 2 && (
                                                <SidebarMenuSubItem>
                                                    <SidebarMenuButton asChild>
                                                        <Link to={"/UpcomingDeliverables"}>
                                                            <span>Deliverables</span>
                                                        </Link>
                                                    </SidebarMenuButton>
                                                </SidebarMenuSubItem>
                                                )}
                                            </SidebarMenuSub>
                                        </CollapsibleContent>
                                    </SidebarMenuItem>
                                </Collapsible><Collapsible className="group">
                                        <SidebarMenuItem>
                                            <CollapsibleTrigger asChild>
                                                <SidebarMenuButton>
                                                    <Home />
                                                    <span>Project</span>
                                                    <ChevronDown className="ml-auto h-4 w-4 shrink-0 opacity-50 transition group-data-[state=open]:rotate-180" />
                                                </SidebarMenuButton>
                                            </CollapsibleTrigger>
                                            <CollapsibleContent>
                                                <SidebarMenuSub>
                                                    <SidebarMenuSubItem>
                                                        <SidebarMenuButton asChild>
                                                            <Link to={"/Charter"}>
                                                                <span>Charter</span>
                                                            </Link>
                                                        </SidebarMenuButton>
                                                    </SidebarMenuSubItem>
                                                    {app.authLevel >= 2 && (
                                                    <><SidebarMenuSubItem>
                                                            <SidebarMenuButton asChild>
                                                                <Link to={"/Plan"}>
                                                                    <span>Plan</span>
                                                                </Link>
                                                            </SidebarMenuButton>
                                                        </SidebarMenuSubItem><SidebarMenuSubItem>
                                                                <SidebarMenuButton asChild>
                                                                    <Link to={"/Risks"}>
                                                                        <span>Risks</span>
                                                                    </Link>
                                                                </SidebarMenuButton>
                                                            </SidebarMenuSubItem><SidebarMenuSubItem>
                                                                <SidebarMenuButton asChild>
                                                                    <Link to={"/Actions"}>
                                                                        <span>Actions</span>
                                                                    </Link>
                                                                </SidebarMenuButton>
                                                            </SidebarMenuSubItem><SidebarMenuSubItem>
                                                                <SidebarMenuButton asChild>
                                                                    <Link to={"/Issues"}>
                                                                        <span>Issues</span>
                                                                    </Link>
                                                                </SidebarMenuButton>
                                                            </SidebarMenuSubItem><SidebarMenuSubItem>
                                                                <SidebarMenuButton asChild>
                                                                    <Link to={"/Decisions"}>
                                                                        <span>Decisions</span>
                                                                    </Link>
                                                                </SidebarMenuButton>
                                                            </SidebarMenuSubItem><SidebarMenuSubItem>
                                                                <SidebarMenuButton asChild>
                                                                    <Link to={"/SupportRequests"}>
                                                                        <span>Support Requests</span>
                                                                    </Link>
                                                                </SidebarMenuButton>
                                                            </SidebarMenuSubItem><SidebarMenuSubItem>
                                                                <SidebarMenuButton asChild>
                                                                    <Link to={"/Team"}>
                                                                        <span>Team</span>
                                                                    </Link>
                                                                </SidebarMenuButton>
                                                            </SidebarMenuSubItem></>
                                                    )}
                                                </SidebarMenuSub>
                                            </CollapsibleContent>
                                        </SidebarMenuItem>
                                    </Collapsible><SidebarMenuItem>
                                        <SidebarMenuButton asChild>
                                            <Link to={"/Reports"}>
                                                <Calendar />
                                                <span>Reports</span>
                                            </Link>
                                        </SidebarMenuButton>
                                    </SidebarMenuItem></>
                        )}
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild>
                                    <Link to={"/Settings"}>
                                        <Settings />
                                        <span>Settings</span>
                                    </Link>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild>
                                    <Link to={"/Training"}>
                                        <MessageCircleQuestion />
                                            <span>Help</span>
                                    </Link>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                            {/* <Collapsible className="group">
                                <SidebarMenuItem>
                                    <CollapsibleTrigger asChild>
                                        <SidebarMenuButton>
                                            <MessageCircleQuestion />
                                            <span>Help</span>
                                            <ChevronDown className="ml-auto h-4 w-4 shrink-0 opacity-50 transition group-data-[state=open]:rotate-180" />
                                        </SidebarMenuButton>
                                    </CollapsibleTrigger>
                                    <CollapsibleContent>
                                        <SidebarMenuSub>
                                            <SidebarMenuSubItem>
                                                <SidebarMenuButton asChild>
                                                    <Link to={"/Training"}>
                                                        <span>Training Videos</span>
                                                    </Link>
                                                </SidebarMenuButton>
                                            </SidebarMenuSubItem>
                                            <SidebarMenuSubItem>
                                                <SidebarMenuButton asChild>
                                                    <Link to={"/RagGuidelines"}>
                                                        <span>Rag Guidelines</span>
                                                    </Link>
                                                </SidebarMenuButton>
                                            </SidebarMenuSubItem>
                                            <SidebarMenuSubItem>
                                                <SidebarMenuButton asChild>
                                                    <Link to={"/Help"}>
                                                        <span>Help Manual</span>
                                                    </Link>
                                                </SidebarMenuButton>
                                            </SidebarMenuSubItem>
                                            <SidebarMenuSubItem>
                                                <SidebarMenuButton asChild>
                                                    <Link to={"/Policies"}>
                                                        <span>Policies</span>
                                                    </Link>
                                                </SidebarMenuButton>
                                            </SidebarMenuSubItem>
                                        </SidebarMenuSub>
                                    </CollapsibleContent>
                                </SidebarMenuItem>
                            </Collapsible> */}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
            <SidebarFooter>
                 <ModeToggle /> 
                <SidebarMenuButton asChild>
                    <LogoutLink>
                        <LogOut />
                        <span>Logout</span>
                    </LogoutLink>
                </SidebarMenuButton>
            </SidebarFooter>
        </Sidebar>
    )
}
